     <!-- //------------------------------------------ All Batches -------------------------------------------->
<br>
<div class="hidden-xs filter-sidebar" [ngClass]="{'filter-sidebar-closed col-md-1' : !filterOpenState, 'col-md-3' : filterOpenState}">
    <div class="panel panel-default">
       <div class="panel-body">
           <div class="filter-body">
               <span class="lead"> {{LOCALIZATION.batchFilter}} </span>
               <hr>
               <form>
					<div class="bottom-spacing">
						<label for="filterField">{{LOCALIZATION.filterBy}}</label> 					
						<select id="filterField" name="filterField" class="form-control" [(ngModel)]="filter.active">
						  <option *ngFor="let filter of filters" [ngValue]="filter">{{ filter.label }}</option>
						</select>						
					</div>
                   <div class="bottom-spacing" [hidden]="filter.active && (filter.active.name == 'state' || filter.active.name == 'priority')">
                       <div>
							<input id="filterValue" name="filterValue" class="form-control"
								placeholder="{{LOCALIZATION.workflowFilterPlaceholder}}"
								type="text" [(ngModel)]="filter.value"
								(keyup.enter)="applyFilter()" />
                       	</div>
                       <div class="help-block">% - A wildcard for zero or more characters.</div>
                   </div> 
                   <div class="bottom-spacing" *ngIf="filter.active && filter.active.name == 'state'">
                       <select class="form-control" name="filterValue" [(ngModel)]="filter.value">
                           <option value="INITIAL">INITIAL</option>
                           <option value="IN_PROGRESS">IN_PROGRESS</option>
                           <option value="COMPLETED">COMPLETED</option>
                           <option value="ERROR">ERROR</option>
                           <option value="ABORTED">ABORTED</option>
                       </select>
                   </div>
                   <div class="bottom-spacing" *ngIf="filter.active && filter.active.name == 'priority'">
                       <select class="form-control" name="filterValue" [(ngModel)]="filter.value">
                           <option value="Low">Low</option>
                           <option value="Medium">Medium</option>
                           <option value="High">High</option>
                       </select>
                   </div> 
                   <div>
                       <div class="primary-controls">
                           <button class="btn btn-default delete" (click)="clearFilter()">
                           		<span aria-hidden="true"></span> {{LOCALIZATION.clear}} 
                           </button>
                           <button class="btn btn-primary submit-button" (click)="applyFilter()">
                           		<span class="fas fa-filter" aria-hidden="true"></span> {{LOCALIZATION.filter}} 
                           </button>
                       </div>
                   </div>
               </form>
           </div>
       </div>
   </div>
</div>             
<div class="filter-sidebar" [ngClass]="{'col-xs-12 col-md-11' : !filterOpenState, 'col-xs-12 col-md-9' : filterOpenState}">               
      <div class="dx-item-list-page">
        <div class="col-sm-12 col-md-12">
          <div class="clearfix">
            <div *ngIf="batches && batches.length > 0" class='pull-right primary-controls'>
              <button class="btn btn-primary btn-circle" (click)="loadBatches(1)" [disabled]="inprogress" title="{{LOCALIZATION.refresh}}"><i class="fas fa-sync"></i></button>
              <button *ngIf="batches && selectedBatches.selected > 0 && selectedBatches.canRetry && userPermissions['ROLE_DECLASS_WORKFLOW_SUPERVISOR']" class="btn btn-circle btn-primary" title="Restart batches" (click)="onRetry()"><i class="fas fa-undo" aria-hidden="true"></i></button>
              <button *ngIf="batches && selectedBatches.selected > 0 && selectedBatches.canAbort && userPermissions['ROLE_DECLASS_WORKFLOW_SUPERVISOR']" class="btn btn-circle btn-danger" title="Abort batch processing" (click)="onAbort()"><i class="fas fa-ban" aria-hidden="true"></i></button>
              <button *ngIf="batches && selectedBatches.selected > 0 && selectedBatches.canDelete && userPermissions['ROLE_DECLASS_WORKFLOW_SUPERVISOR']" class="btn btn-circle btn-danger" title="Delete batches" (click)="onDelete()"><i class="fas fa-trash" aria-hidden="true"></i></button>                        
            </div>
          </div>
          <table *ngIf="batches && batches.length > 0" class='table table-hover table-condensed dx-table'>
            <thead>
               <tr>
                  <th *ngIf="userPermissions['ROLE_DECLASS_WORKFLOW_SUPERVISOR']" class="dx-checkbox-col">
                    <label style="display:inline;" class="control control--checkbox">
                      <input aria-label="Select all" type="checkbox" [(ngModel)]="selectedBatches.all" (click)="toggleAllBatches()"/>
                      <div class="control__indicator"></div>
                    </label>
                  </th>
                  <th class="pointMe sortable truncate" (click)="sortingChanged('name')" title="{{LOCALIZATION.batch}}">{{LOCALIZATION.batch}}</th>
                  <th class="hidden-xs truncate" title="{{LOCALIZATION.documents}}">{{LOCALIZATION.documents}}</th>
                  <th class="pointMe sortable truncate" (click)="sortingChanged('state')" title="{{LOCALIZATION.batchStatus}}">{{LOCALIZATION.batchStatus}}</th>
                  <th class="hidden-sm hidden-xs pointMe sortable truncate" (click)="sortingChanged('priority')" title="{{LOCALIZATION.priority}}">{{LOCALIZATION.priority}}</th>
                  <th class="hidden-sm hidden-xs pointMe sortable truncate" (click)="sortingChanged('dueDate')" title="{{LOCALIZATION.dueDate}}">{{LOCALIZATION.dueDate}}</th>
                  <th class="hidden-sm hidden-xs pointMe sortable truncate" (click)="sortingChanged('owner')" title="{{LOCALIZATION.creator}}">{{LOCALIZATION.creator}}</th>
                  <th class="hidden-sm hidden-xs pointMe sortable truncate" (click)="sortingChanged('creationDate')" title="{{LOCALIZATION.createdDate}}">{{LOCALIZATION.createdDate}}</th>
                  <th class="hidden-xs pointMe sortable truncate" (click)="sortingChanged('workflowType')" title="{{LOCALIZATION.workflow}}">{{LOCALIZATION.workflow}}</th>                            
                  <th class="text-center" style="width: 10%" title="{{LOCALIZATION.actions}}"><span class="hidden-xs">{{LOCALIZATION.actions}}</span></th>
               </tr>
            </thead>
            <tbody>
              <tr *ngFor='let batch of batches'>
                <td *ngIf="userPermissions['ROLE_DECLASS_WORKFLOW_SUPERVISOR']">
                  <label class="control control--checkbox">
                    <input [(ngModel)]="batch.selected" (change)="toggleBatchId(batch.batchId)" type="checkbox"/>
                    <div class="control__indicator"></div>
                  </label>
                </td>
                <td class="truncate">
					<a title="{{ LOCALIZATION.viewDetails }} - {{ batch.batchName }}" 
					   (click)="showDocumentsProperties(batch)" 
					   class="pointMe"
					   [innerHTML]="trustHtml(batch.batchName_decorated || batch.batchName)">
					</a>
                </td>
                <td class="hidden-xs"><p class="truncate" title="{{batch.documents.length}}">{{batch.documents.length}}</p></td>
                <td><p class="truncate" title="{{batch.state}}">{{batch.state}}</td>
                <td class="hidden-sm hidden-xs"><p class="truncate" title="{{batch.priority}}">{{batch.priority}}</p></td>
                <td class="hidden-sm hidden-xs"><p class="truncate" title="{{batch.dueDateStr}}">{{batch.dueDateStr || LOCALIZATION.none}}</p></td>
                <td class="hidden-sm hidden-xs"><p class="truncate" title="{{batch.owner}}">{{batch.owner}}</p></td>
                <td class="hidden-sm hidden-xs"><p class="truncate" title="{{batch.createdDateStr}}">{{batch.createdDateStr}}</p></td>
                <td class="hidden-xs"><p class="truncate" title="{{batch.workflowType}}">{{batch.workflowType}}</p></td>
                <td class="text-center">                         
                <div class="dropdown" id="workflow-operations-div" ngbDropdown>
				  <button ngbDropdownToggle
					  type="button"
					  class="dropdown-toggle dropdown-toggle-fixed btn-xs btn-menu center-block"
					  aria-haspopup="true"
					  aria-expanded="false"
					  [attr.aria-label]="LOCALIZATION.actions"
					  title="{{LOCALIZATION.actions}}"
					  style="border: 0; background: transparent;">
						<i class="nav-icon fa fa-ellipsis-v" aria-hidden="true"></i>
				  </button>								  
                     <ul class="dropdown-menu custom-drop" ngbDropdownMenu [attr.aria-label]="LOCALIZATION.optionsList" role="menu">
                      <li role="menuitem">
                      	<a (click)="showBatchProperties(batch)" title="Show the batch properties" class="pointMe menuitem">{{LOCALIZATION.properties}}</a>
                      </li>
                      <li role="menuitem">
                     	 <a (click)="showBatchLogs(batch)" title="Show the batch logs" class="pointMe menuitem">{{LOCALIZATION.logs}}</a>
                      </li>
                      <li role="menuitem" *ngIf="batch.hasQueries">
                      	<a (click)="showQueriesProperties(batch)" title="Show the queries assigned to the batch" class="pointMe menuitem">{{LOCALIZATION.assignedQueries}}</a>
                      </li>
                      <!-- Result statistics for Air Force pilot. TODO: base display on config. -->
                      <!-- 
                      <li role="menuitem"><a (click)="showBatchStatistics(batch)" title="Show batch result statistics" class="pointMe menuitem">Result Statistics</a></li>
                       -->
                      <li class="divider"></li>
                      <li role="menuitem" *ngIf="'COMPLETED' == batch.state  && (userPermissions['ROLE_PRODUCT_VIEW'] || userPermissions['ROLE_PRODUCT_VIEW_RESTRICTED'])">
                          <a (click)="downloadResults(batch.batchId, batch.batchName)" title="Download batch results" class="pointMe menuitem">{{LOCALIZATION.downloadResults}}</a>
                      </li>
                      <!-- Result statistics for Air Force pilot. TODO: base display on config. -->
                      <!-- 
                      <li role="menuitem" *ngIf="(userPermissions['ROLE_PRODUCT_VIEW'] || userPermissions['ROLE_PRODUCT_VIEW_RESTRICTED'])">
                          <a (click)="downloadBatchStatistics(batch)" title="Download batch result statistics" class="pointMe menuitem">Download Statistics</a>
                      </li> 
                       -->                               
                      <li class="divider"></li>
                      <li role="menuitem" *ngIf="batch.actions.canRetry && userPermissions['ROLE_DECLASS_WORKFLOW_SUPERVISOR']">
                      	<a (click)="onRetry(batch.batchId)" title="Restart this batch" class="pointMe menuitem-info">{{LOCALIZATION.restart}}</a>
                      </li>
                      <li role="menuitem" *ngIf="batch.actions.canAbort && userPermissions['ROLE_DECLASS_WORKFLOW_SUPERVISOR']">
                      	<a (click)="onAbort(batch.batchId)" title="Abort this batch" class="pointMe menuitem-danger">{{LOCALIZATION.abort}}</a>
                      </li>                          
                      <li role="menuitem" *ngIf="batch.actions.canDelete && userPermissions['ROLE_DECLASS_WORKFLOW_SUPERVISOR']">
                      	<a (click)="onDelete(batch.batchId)" title="Delete this batch" class="pointMe menuitem-danger">{{LOCALIZATION.deleteItem}}</a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
           </table>
          <div *ngIf="!inprogress && (!batches || batches.length == 0)"> <i>{{LOCALIZATION.resultsEmpty}}</i></div>
          <div *ngIf="inprogress"> <i>{{LOCALIZATION.loading}}</i></div>
      </div>
		<div class="tab-pagination-container">
			<div *ngIf="pagination && pagination.totalElements > 0" class="text-center">
				<div style="display: inline-flex; gap: 5px; align-items: center; margin-bottom: 10px;">
					<div *ngIf="batches && batches.length > 0" class="btn-group dropup hidden-xs" ngbDropdown>
						<button ngbDropdownToggle id="pageSizeButton" type="button"
							class="btn btn-primary submit-button submit-button-sm">
							{{LOCALIZATION.showing}} 
							<span class="badge" style="margin-right: 4px;">{{pagination.elementsPerPage}}</span><span class="caret"></span>
						</button>
						<ul ngbDropdownMenu class="dropdown-menu custom-drop" role="menu" aria-labelledby="pageSizeButton">
							<li role="menuitem" (click)="pageSizeChanged(10)"><a>10</a>
							</li>
							<li class="divider"></li>
							<li role="menuitem" (click)="pageSizeChanged(25)"><a>25</a>
							</li>
							<li class="divider"></li>
							<li role="menuitem" (click)="pageSizeChanged(50)"><a>50</a>
							</li>
						</ul>
					</div>
					<div class="hidden-xs current-page">{{pagination.pageGap}} - {{pagination.resultTotal}} {{LOCALIZATION.of}} {{pagination.totalElements}}</div>
					<ngb-pagination class="pagination custom-page pagination-sm"
						[(page)]="pagination.page" 
						[pageSize]="pagination.elementsPerPage"
						[collectionSize]="pagination.totalElements"
						(pageChange)="pagination.pageChanged($event)" 
						[maxSize]="5"
						[boundaryLinks]="true" 
						previousText="&#xf053;" 
						nextText="&#xf054;"
						firstText="&#xf053;&#xf053;" 
						lastText="&#xf054;&#xf054;">
					</ngb-pagination>
				</div>
			</div>
		</div>
    </div>
</div>              
